const config = {
  authUrl: process.env.REACT_APP_AUTH_API_ENDPOINT,
  workflowUrl: process.env.REACT_APP_WORKFLOW_API_ENDPOINT,
  peopleTemplateUrl: process.env.REACT_APP_PEOPLE_TEMPLATE_URL,
  quicklinkUrl: process.env.REACT_APP_QUICKLINK_API_ENDPOINT,
  dummyBanner1url: process.env.REACT_APP_PACKAGE_DUMMY_BANNER_1_URL,
  dummyBanner2url: process.env.REACT_APP_PACKAGE_DUMMY_BANNER_2_URL,
  dummyBanner3url: process.env.REACT_APP_PACKAGE_DUMMY_BANNER_3_URL,
  eventExpenseUploadurl: process.env.REACT_APP_EVENT_EXPENSE_TEMPLATE_URL,
  miceExpenseUploadurl: process.env.REACT_APP_MICE_EXPENSE_TEMPLATE_URL,
  hotelTemplateUrl: process.env.REACT_APP_HOTEL_TEMPLATE_URL,
  foodMenuTemplateUrl: process.env.REACT_APP_FOOD_MENU_TEMPLATE_URL,
  eventKey: process.env.REACT_APP_EVENT_KEY,
  userKey: process.env.REACT_APP_USER_KEY,
  packageKey: process.env.REACT_APP_PACKAGE_KEY,
  notificationPeople: process.env.REACT_APP_NOTIFICATION_TEPEOPLE_TEMPLATE,
  imageKey: process.env.REACT_APP_IMAGE_KEY,
  tokenKey: process.env.REACT_APP_TOKEN_KEY,
  bucketPath: process.env.REACT_APP_BUCKET_PATH_URL,
  apiResponseKey: process.env.REACT_APP_API_RESPONSE_KEY,
};

export default config;
